module.exports = __webpack_public_path__ + "img/CS_3_Section_5_background-01.4aaf74eb.png";